module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp-1",
    attrs: {
      "id": "intro"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "INTO"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“They say time happens all at once,” the woman says. “Did you ever hear that?” She stands in the surf wearing a blue dress that billows in the wind. The dress looks like one my mom used to wear on Sundays until somebody spilled bleach on it.")])]), _vm._v(" "), _c('p', {
    staticClass: "INTX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("I shake my head. “What did you do with your shoes?” I ask. There are so many families on the outing today that I can’t tell at first whose parents are whose. But she isn’t anybody’s mother. I’ve worked that out now.")])]), _vm._v(" "), _c('p', {
    staticClass: "INTX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The sun is at her back, so her face is in shadow, but I can tell she’s smiling. “Past, present, and future, all rolled in together,” she goes on. “So it doesn’t matter what you do, does it? It doesn’t matter, sure it doesn’t.”")])]), _vm._v(" "), _c('p', {
    staticClass: "INTX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("I don’t know why this lady wants to talk to me. I don’t understand why she’s telling me this stuff, when I’m just some kid digging for sand crabs along the shoreline of a country I’ve never been to before. From somewhere—all the way down the far end of the beach, it sounds like—I can hear my sister laughing.")])]), _vm._v(" "), _c('p', {
    staticClass: "INTX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“You don’t see it yet, but you will.” The wind lifts the woman’s long black hair and makes darting shapes with it in the bright air. “It’s happened, it’s done, and that means you can do anything you like.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33bfd489","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/prologue.vue
// module id = 69
// module chunks = 0